"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventsContainer = void 0;

var web_1 = require("@thesisedu/web");

var react_1 = __importDefault(require("react"));

var MediaPlaybackContext_1 = require("./MediaPlaybackContext");

var HOVER_TIMEOUT = 5000;

function EventsContainer(_ref) {
  var setFooterVisible = _ref.setFooterVisible,
      setOverFooter = _ref.setOverFooter;
  var hideTimeoutRef = react_1.default.useRef();

  var _ref2 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      onSetPlaying = _ref2.onSetPlaying;

  return react_1.default.createElement(_EventsContainer, {
    onMouseEnter: function onMouseEnter() {
      setFooterVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      hideTimeoutRef.current = undefined;
      setFooterVisible(false);
    },
    onMouseMove: function onMouseMove() {
      setFooterVisible(true);

      if (hideTimeoutRef.current) {
        clearInterval(hideTimeoutRef.current);
      }

      hideTimeoutRef.current = setTimeout(function () {
        setFooterVisible(false);
      }, HOVER_TIMEOUT);
    },
    onTouchEnd: function onTouchEnd() {
      setTimeout(function () {
        setFooterVisible(false);
        setOverFooter(false);
      }, HOVER_TIMEOUT);
    },
    onClick: function onClick() {
      onSetPlaying(function (p) {
        return !p;
      });
    }
  });
}

exports.EventsContainer = EventsContainer;

var _EventsContainer = web_1.styled.div(_templateObject());